export default "/bottom_scooter_logo.12ad911e-bec5a4.svg?svgr";